import api from './api';
import { Coupon, CouponValidation, CouponDiscount, CouponUsageLog } from '@/types/coupon';

export const couponApi = {
    // Tüm kuponları listele (admin)
    async getAllCoupons(): Promise<Coupon[]> {
        try {
            console.log('📡 Calling GET /admin/coupons');
            const response = await api.get('/admin/coupons');
            console.log('📥 Response:', response.data);
            return response.data;
        } catch (error: any) {
            console.error('❌ Coupon API Error:', error.response || error);
            throw new Error(error.response?.data?.error || 'Kupon listesi yüklenemedi');
        }
    },

    // Kupon detayı getir
    async getCoupon(couponId: string): Promise<Coupon> {
        try {
            const response = await api.get(`/admin/coupons/${couponId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching coupon:', error);
            throw new Error(error.response?.data?.error || 'Kupon yüklenemedi');
        }
    },

    // Yeni kupon oluştur (admin)
    async createCoupon(couponData: Omit<Coupon, 'id' | 'createdAt' | 'updatedAt' | 'currentUses'>): Promise<Coupon> {
        try {
            const response = await api.post('/admin/coupons', {
                ...couponData,
                currentUses: 0,
            });
            return response.data;
        } catch (error: any) {
            console.error('Error creating coupon:', error);
            const errorMessage = error.response?.data?.details || error.response?.data?.error || 'Kupon oluşturulamadı';
            throw new Error(errorMessage);
        }
    },

    // Kupon güncelle (admin)
    async updateCoupon(couponId: string, couponData: Partial<Omit<Coupon, 'id' | 'createdAt' | 'updatedAt'>>): Promise<Coupon> {
        try {
            const response = await api.put(`/admin/coupons/${couponId}`, couponData);
            return response.data;
        } catch (error: any) {
            console.error('Error updating coupon:', error);
            throw new Error(error.response?.data?.error || 'Kupon güncellenemedi');
        }
    },

    // Kupon sil (admin)
    async deleteCoupon(couponId: string): Promise<{ message: string }> {
        try {
            const response = await api.delete(`/admin/coupons/${couponId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error deleting coupon:', error);
            throw new Error(error.response?.data?.error || 'Kupon silinemedi');
        }
    },

    // Kupon kullanım loglarını getir (admin)
    async getUsageLogs(couponId: string): Promise<CouponUsageLog[]> {
        try {
            const response = await api.get(`/admin/coupons/${couponId}/usage-logs`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching usage logs:', error);
            throw new Error(error.response?.data?.error || 'Kullanım logları yüklenemedi');
        }
    },

    // Kuponu doğrula (public)
    async validateCoupon(code: string, orderAmount: number, vendorId?: string): Promise<CouponValidation & { discount?: CouponDiscount }> {
        try {
            const response = await api.post('/web/validate-coupon', {
                code,
                orderAmount,
                vendorId,
            });
            return response.data;
        } catch (error: any) {
            console.error('Error validating coupon:', error);
            if (error.response?.data?.error) {
                return {
                    valid: false,
                    error: error.response.data.error,
                };
            }
            throw error;
        }
    },
};
